export default __webpack_public_path__ + "static/media/mov.137c69b3.svg";